// export const baseUrl = "https://localhost:44334/";
// export const baseUrl = "http://shandoo-001-site1.ctempurl.com/";

// // export const baseUrl = "https://api.golearn.site/";
// export const baseUrl = "https://restfulapi.golearn.site/";
export const baseUrl = "https://www.exciting-swartz.162-220-162-242.plesk.page/";
export const baseUrlTest = "https://www.exciting-swartz.162-220-162-242.plesk.page/";
// export const baseUrlTest = "https://backend.mrahmedfarg.com/";
// export const baseUrl = "https://backend.mrahmedfarg.com/";

// export const baseUrl = "http://ddd.somee.com/";
